import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ViewEncapsulation,
  ElementRef,
  Renderer,
  Optional,
  NgModule,
  OnInit,
  AfterViewInit
} from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { OListItemComponent } from '../list-item/o-list-item.component';
import { OListItemTextRenderer } from './o-list-item-text-renderer.class';
import { OSharedModule } from '../../../shared';

export const DEFAULT_INPUTS_O_LIST_ITEM_AVATAR = [
  ...OListItemTextRenderer.DEFAULT_INPUTS_O_TEXT_RENDERER,
  'avatar',

  'emptyAvatar: empty-avatar',

  // avatar-type [base64|url]: avatar type (extern url or base64). Default: no value.
  'avatarType: avatar-type'
];

export const DEFAULT_OUTPUTS_O_LIST_ITEM_AVATAR = [
  ...OListItemTextRenderer.DEFAULT_OUTPUTS_O_TEXT_RENDERER
];



export class OListItemAvatarComponent extends OListItemTextRenderer implements OnInit, AfterViewInit {

  protected avatar: string;
  protected avatarType: string;
  protected emptyAvatar: string;
  protected _avatarSrc: SafeResourceUrl;

  constructor(
    elRef: ElementRef,
    _renderer: Renderer,
    _injector: Injector,
      protected _listItem: OListItemComponent,
    public sanitizer: DomSanitizer
  ) {
    super(elRef, _renderer, _injector, _listItem);
  }

  ngAfterViewInit() {
    this.modifyMdListItemElement();
  }

  ngOnInit() {
    let avatarValue: any = this.avatar;
    if (!this.avatar) {
      avatarValue = this.emptyAvatar;
    } else {
      switch (this.avatarType) {
        case 'base64':
          avatarValue = ('data:image/png;base64,' + ((typeof (avatarValue.bytes) !== 'undefined') ? avatarValue.bytes : avatarValue));
          break;
        case 'url':
        default:
          avatarValue = this.avatar;
          break;
      }
    }
    this.avatarSrc = this.sanitizer.bypassSecurityTrustResourceUrl(avatarValue);
  }

  get avatarSrc(): SafeResourceUrl {
    return this._avatarSrc;
  }

  set avatarSrc(val: SafeResourceUrl) {
    this._avatarSrc = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-item-avatar',
  template: `
    <div fxLayout="row" fxLayoutAlign="center center">
      <img mdListAvatar class="avatar" [src]="avatarSrc" [alt]="title">
      <div class="mat-list-text">
        <h3 mdLine class="primary-text"> {{ title }} </h3>
        <h4 *ngIf="primaryText !== undefined" mdLine class="primary-text">{{ primaryText }}</h4>
        <p *ngIf="secondaryText !== undefined" mdLine class="secondary-text">{{ secondaryText }}</p>
      </div>
      <md-icon *ngIf="icon !== undefined" [class.top]="has3Lines" class="material-icons o-list-item-icon" (click)="onActionIconClick($event)">{{ icon }}</md-icon>
    </div>
  `,
  styles: [`
    .o-list-row-action+.o-list-item-avatar{padding:0px 0px 0px 10px}.mat-list.selectable .o-list-item-avatar .mat-list-text{padding-right:0px}.mat-list .mat-list-item .mat-list-item-content .o-list-item-avatar.o-custom-list-item .mat-list-text,.mat-nav-list .mat-list-item .mat-list-item-content .o-list-item-avatar.o-custom-list-item .mat-list-text{padding:0 16px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST_ITEM_AVATAR
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIST_ITEM_AVATAR
  ],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-custom-list-item]': 'true',
    '[class.o-list-item-avatar]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Injector, },
{type: OListItemComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OListItemComponent), ] }, ]},
{type: DomSanitizer, },
];
}


export class OListItemAvatarModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListItemAvatarComponent],
  imports: [
    OSharedModule,
    CommonModule
  ],
  exports: [OListItemAvatarComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
